import { CLIENT_MESSAGES, type InteractMessage } from '@veriverse/shared';
import { useSessionStore } from '../state/session-store.js';

/** Sends `interact` for an object (spec §6.6); the server checks range, cooldown and permission. */
export function sendInteract(objectId: number, action?: string, data?: unknown): void {
  const room = useSessionStore.getState().room;
  if (!room) return;
  const message: InteractMessage = { objectId };
  if (action !== undefined) message.action = action;
  if (data !== undefined) message.data = data;
  room.send(CLIENT_MESSAGES.interact, message);
}
